import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', py: 6 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
            Privacy Policy
          </Typography>
          <Divider sx={{ mb: 4 }} />
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            At Shoora Welfare, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you interact with our website and services.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Information We Collect
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            We may collect personal information such as your name, email address, phone number, and other details when you voluntarily provide them through forms or other interactions on our website.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            How We Use Your Information
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            The information we collect is used to provide and improve our services, respond to your inquiries, process donations, and communicate updates about our activities.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Information Sharing
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            We do not sell, trade, or rent your personal information to third parties. However, we may share your information with trusted partners who assist us in operating our website and conducting our activities, provided they agree to keep your information confidential.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Data Security
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Your Consent
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            By using our website, you consent to the terms of this Privacy Policy. If you do not agree with this policy, please do not use our website.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Changes to This Policy
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            We reserve the right to update this Privacy Policy at any time. Any changes will be posted on this page, and the updated policy will take effect immediately upon posting.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.primary' }}>
            If you have any questions or concerns about this Privacy Policy, please contact us at <strong>shoorawelfare@gmail.com</strong>.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
